import type { TutorialDeps } from './types';
import {
  createTutorialHintDom,
  positionTutorialHint,
  destroyTutorialHint,
} from './ui';

const STEP2_HINT_TEXT =
  'Отлично! Собери всю картинку и она отправится в коллекцию!';

export type Step2State = {
  hintEl: HTMLElement;
  hintDismissed: boolean;
};

/**
 * Вход в Step 2: показываем подсказку над лотком (без стрелки).
 * Нормальный геймплей уже восстановлен через onStepComplete(1) и destroyStep1.
 */
export function enterStep2(deps: TutorialDeps): Step2State {
  const hintEl = createTutorialHintDom(STEP2_HINT_TEXT);
  const tr = deps.getTrayRect();
  const canvasRect = deps.scene.game.canvas.getBoundingClientRect();
  const cam = deps.scene.cameras.main;
  positionTutorialHint(hintEl, tr, canvasRect, cam.height);
  return { hintEl, hintDismissed: false };
}

export function layoutStep2(state: Step2State, deps: TutorialDeps): void {
  if (state.hintDismissed || !state.hintEl?.parentNode) {
    return;
  }
  const tr = deps.getTrayRect();
  const canvasRect = deps.scene.game.canvas.getBoundingClientRect();
  const cam = deps.scene.cameras.main;
  positionTutorialHint(state.hintEl, tr, canvasRect, cam.height);
}

/**
 * Первый dragend в Step 2: скрываем подсказку навсегда.
 */
export function handleDragEndStep2(state: Step2State): void {
  if (state.hintDismissed) return;
  state.hintDismissed = true;
  destroyTutorialHint(state.hintEl);
}

export function destroyStep2(state: Step2State | null): void {
  if (!state) return;
  destroyTutorialHint(state.hintEl);
}
